import React from 'react';

import StepTitleItem from './StepTitleItem/StepTitleItem'

const StepTitle = props => (
  <div className="StepTitle" >
    <StepTitleItem number={props.stepNumber} />
    <div>
      {props.title}
    </div>
  </div>
);

export default StepTitle;
